export default function Repetidores(props) {
    return( 
        <span>{props.repetidores}</span>
    );
}